import type { SITE_PILOTS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/site-pilots-card/site-pilots-card.fr.ts";

export const SITE_PILOTS_CARD_ENGLISH_LOCALE = {
  title: "Installed pilots on site",
} satisfies typeof SITE_PILOTS_CARD_FRENCH_LOCALE;
